var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"w-full relative pb-14 md:pb-0 md:p-0"},[(_vm.pagination)?_c('SuppliesHeader',{attrs:{"total-requests":_vm.pagination.totalItems,"in-progress":_vm.inProgress}}):_vm._e(),_c('SuppliesTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }